import { render, staticRenderFns } from "./WidgetImmovable.vue?vue&type=template&id=a571c602&scoped=true"
import script from "./WidgetImmovable.vue?vue&type=script&lang=ts"
export * from "./WidgetImmovable.vue?vue&type=script&lang=ts"
import style0 from "./WidgetImmovable.vue?vue&type=style&index=0&id=a571c602&prod&scoped=true&lang=scss"
import style1 from "./WidgetImmovable.vue?vue&type=style&index=1&id=a571c602&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a571c602",
  null
  
)

export default component.exports